// extracted by mini-css-extract-plugin
module.exports = {"list":"_8658","item":"_14470"};